module.exports = __webpack_public_path__ + "static/img/news10.0c2dc5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news4/news10.jpg
// module id = YZ4q
// module chunks = 1